import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { StrongAlert } from './facetDesignLike/strongAlert';

export const phaseOverrides = buildFacetDesignOverride()
  .nameOverride('whatToExpectNextMessage', {
    _component: () => StrongAlert,
    _customProps: { status: 'info' },
  }, overrideReadOnly)
  // These are handled differently, don't let the normal overrides try to render them
  .nameOverride('planSteps', { hidden: true }, overrideReadOnly)
  .nameOverride('planPhaseSummary', { hidden: true }, overrideReadOnly)
  .done();
